import { useEffect, useState } from "react";
import LivePl from "./LivePl/LivePl";

const fmt = require("indian-number-format");

export default function SummaryCard({ item, onCalculated, userType }) {
  const [pfdata, setPfdata] = useState([]);
  const [total, setTotal] = useState(0);

  // ⭐ Helper for conditional CSS
  const cls = (...names) => {
    return userType === 1 ? [...names, "small"].join(" ") : names.join(" ");
  };

  const LivePlTotal = (id, pf) => {
    if (!Array.isArray(item.standing) || item.standing.length === 0) return;

    setPfdata((prev) => {
      const updated = [...prev];
      const index = updated.findIndex((x) => x.id === id);

      if (index === -1) {
        updated.push({ id, pf });
      } else {
        updated[index].pf = pf;
      }

      const newTotal = updated.reduce(
        (sum, entry) => sum + parseFloat(entry.pf || 0),
        0,
      );

      setTotal(newTotal);
      return updated;
    });
  };

  useEffect(() => {
    if (onCalculated && typeof onCalculated === "function") {
      const upperShare = parseFloat(item.upper_sharing) || 0;
      const selfShare = parseFloat(item.self_sharing) || 0;
      const lowerShare = parseFloat(item.lower_sharing) || 0;

      const liveUpper = (parseFloat(total) * parseFloat(upperShare)) / 100;
      const liveSelf = (parseFloat(total) * parseFloat(selfShare)) / 100;
      const liveLower = (parseFloat(total) * parseFloat(lowerShare)) / 100;

      const combinedUpper = parseFloat(item.upper) - parseFloat(liveUpper);
      const combinedSelf = parseFloat(item.self) - parseFloat(liveSelf);
      const combinedLower = parseFloat(item.lower) - parseFloat(liveLower);
 
      onCalculated({
        id: item.super_id,
        username: item.super_username,
        booked: parseFloat(item.booked).toFixed(0),
        total: parseFloat(total).toFixed(0),
        net_total: parseFloat(parseFloat(item.booked) + parseFloat(total)).toFixed(0),
        upper: parseFloat(combinedUpper).toFixed(0),
        self: parseFloat(combinedSelf).toFixed(0),
        lower: parseFloat(combinedLower).toFixed(0),
        upperLive: parseFloat(liveUpper).toFixed(0) * -1,
        selfLive: parseFloat(liveSelf).toFixed(0) * -1,
        lowerLive: parseFloat(liveLower).toFixed(0) * -1,
        shares: {
          upper: upperShare,
          self: selfShare,
          lower: lowerShare,
        },
      });
    }
  }, [total]);

  const OpenEdit = () => {
    window.user_id = item.super_id;
    if (typeof window.openeditSuper === "function") {
      window.openeditSuper();
    }
  };

  const formatVal = (val) => fmt.format(parseFloat(Math.abs(val) || 0).toFixed(0));
  const isProfit = total > 0;

  // ⭐ Combined Booked + Live
  const getCombined = (booked, shareKey) => {
    const shareValue = parseFloat(item[shareKey]) || 0;

    const livePortion =
      ((Math.abs(total) * shareValue) / 100) * (total >= 0 ? 1 : -1);

    const combined = parseFloat(booked || 0) - livePortion;

    return {
      value: combined,
      share: shareValue,
      color: combined >= 0 ? "buytext" : "selltext",
    };
  };

  const netBooked = parseFloat(item.booked) + parseFloat(total);

  return (
    <div className="menuContainer addHight text">
      {/* Live P/L Rows */}
      {Array.isArray(item.standing) &&
        item.standing.length > 0 &&
        item.standing.map((i) => (
          <LivePl
            key={i.id}
            item={i}
            total={item.standing.length}
            LivePlTotal={LivePlTotal}
          />
        ))}

      {/* Username */}
      <div onClick={OpenEdit} className={cls("menuUsername", "large")}>
        <div className="user_id">{item.super_username}</div>
      </div>

      {/* Booked */}
      <div
        className={cls(
          "menuUsername",
          "large",
          item.booked > 0 ? "buytext" : "selltext",
        )}
      >
        {formatVal(item.booked)}
      </div>

      <div
        className={`menuUsername large ${total > 0 ? "buytext" : "selltext"} ${userType === 1 ? "small" : ""}`}
      >
        {formatVal(total)}
      </div>
      {/* Booked+Live = NET */}
      <div
        className={`menuUsername large ${netBooked > 0 ? "buytext" : "selltext"} ${userType === 1 ? "small" : ""}`}
      >
        {formatVal(netBooked)}
      </div>

      {/* Combined Self / Lower */}
      {[
        { key: "self", shareKey: "self_sharing" },
        { key: "lower", shareKey: "lower_sharing" },
      ].map(({ key, shareKey }) => {
        const { value, share, color } = getCombined(item[key], shareKey);

        return (
          <div key={key} className={cls("menuName", "large", color)}>
            {formatVal(value)} ({share}%)
          </div>
        );
      })}

      {/* Live Portion Breakdown */}
      {["self_sharing", "lower_sharing"].map((shareKey) => {
        const shareValue = parseFloat(item[shareKey]) || 0;
        const livePart = shareValue === 0 ? 0 : (total * shareValue) / 100;

        return (
          <div
            key={shareKey}
            className={cls(
              "menuName",
              "large",
              isProfit ? "selltext" : "buytext",
            )}
          >
            {formatVal(Math.abs(livePart))} ({shareValue}%)
          </div>
        );
      })}
    </div>
  );
}